import React from 'react';
import { Card, CardProps, Stack, styled, Typography } from '@mui/material';
import { calculateActivitiesCountDelta } from 'modules/home/utils';
import { DeltaIcon } from 'modules/home/components/CountStatsSection/DeltaIcon';

interface SummaryTileProps extends CardProps {
  title: string
  count: number
  previousCount?: number
}

const StyledCard = styled(Card)<CardProps>(({ theme }) => ({
  borderLeftStyle: 'solid',
  borderLeftWidth: '5px',
  borderColor: theme.palette.primary.main,
  width: theme.spacing(20),
  height: theme.spacing(8)
}));

export const SummaryTile: React.FC<SummaryTileProps> = ({ title, count, previousCount, ...cardProps }) => {
  const delta = previousCount != undefined
    ? calculateActivitiesCountDelta(count, previousCount)
    : undefined;

  return (
    <StyledCard {...cardProps}>
      <Stack px={2} py={1}>
        <Stack direction='row' justifyContent='space-between'>
          <Typography variant='body1'>{count}</Typography>
          {previousCount != undefined && (
            <Typography variant='subtitle2' display='flex' alignItems='center'>
              {`${delta ?? '-'}%`}
              {delta != undefined ? <DeltaIcon currentValue={count} previousValue={previousCount} /> : <></>}
            </Typography>
          )}
        </Stack>
        <Typography variant='body2'>{title}</Typography>
      </Stack>
    </StyledCard>
  );
};